import { toast } from "react-toastify";
import { handleError } from "../../../../utils/helpers";
import { BaseApiResponse } from "../../../../utils/types";
import { adminBaseApi } from "../../../api";
import {
  GetAllUsersQuery,
  GetAllUsersResponse,
  GetSingleUserResponse,
  ToggleUserSuspendPayload,
} from "./users.types";

export const adminUsersApi = adminBaseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getAllUsers: builder.query<GetAllUsersResponse, GetAllUsersQuery>({
      query: (params) => {
        return {
          url: `admin/users`,
          method: "GET",
          params: { ...params },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    getSingleUser: builder.query<GetSingleUserResponse, { id: string }>({
      query: (params) => {
        return {
          url: `admin/users/${params.id}/details`,
          method: "GET",
          params: { ...params },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    toggleUserSuspension: builder.mutation<
      BaseApiResponse,
      { id: string; data: ToggleUserSuspendPayload }
    >({
      query: (payload) => {
        return {
          url: `admin/users/${payload.id}/update-status`,
          method: "PATCH",
          body: { ...payload.data },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (data.status === "success" && arg.data.action === "suspend") {
            toast.success("Account suspended");
          } else if (
            data.status === "success" &&
            arg.data.action === "unsuspend"
          ) {
            toast.success("Account reactivated");
          }
        } catch (err) {
          handleError(err, true);
        }
      },
    }),
  }),
});

export const {
  useGetAllUsersQuery,
  useGetSingleUserQuery,
  useToggleUserSuspensionMutation,
} = adminUsersApi;
